module.exports = new __parcel__URL__("tide-map.d8641695.svg").toString();